import { appConfig } from '@/config/app.config';
import { createQueryClient } from '@/lib/api/query-client';
import { AppRouterProvider } from '@/router';
import { CustomErrorBoundary } from '@components/error/CustomErrorBoundary';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = createQueryClient();

export function App() {
  return (
    <CustomErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppRouterProvider queryClient={queryClient} />

        {appConfig.isDevelopment && <ReactQueryDevtools initialIsOpen={false} position="bottom" />}
      </QueryClientProvider>
    </CustomErrorBoundary>
  );
}
